import { render, staticRenderFns } from "./DiscussListItem.vue?vue&type=template&id=4106420e&"
import script from "./DiscussListItem.vue?vue&type=script&lang=js&"
export * from "./DiscussListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports